import { Tooltip } from "antd";
import "./style.css";

const UITooltip = (props: any) => {
  const { title, placement, overlayClassName, children } = props;
  return (
    <Tooltip
      title={title}
      placement={placement}
      // Base theme lives on "uiTooltip-overlay" (tooltip/style.css) so every
      // caller gets the same on-brand look by default; a caller-supplied
      // overlayClassName layers on top rather than replacing it.
      overlayClassName={
        overlayClassName ? `uiTooltip-overlay ${overlayClassName}` : "uiTooltip-overlay"
      }
    >
      {children}
    </Tooltip>
  );
};

export default UITooltip;
